export default __webpack_public_path__ + "static/media/resume.86f0a932.pdf";